import { Routes, Route, NavLink } from 'react-router-dom'
import { Toaster } from '@/components/ui/sonner'
import { cn } from '@/lib/utils'
import { seo } from '@shared/seo.config'
import Home from '@/pages/Home'
import Settings from '@/pages/Settings'
import NotFound from '@/pages/NotFound'

const nav = [
  { to: '/', label: 'Tổng quan' },
  { to: '/settings', label: 'Cài đặt' },
]

export default function App() {
  return (
    <div data-upbo-src="src/App.tsx:16" className="flex min-h-dvh flex-col">
      <header data-upbo-src="src/App.tsx:17" className="sticky top-0 z-40 border-b border-border/60 bg-background/80 backdrop-blur-xl">
        <div data-upbo-src="src/App.tsx:18" className="mx-auto flex h-14 w-full max-w-6xl items-center gap-8 px-6">
          <NavLink to="/" className="text-sm font-semibold tracking-tight">
            {seo.siteName}
          </NavLink>
          <nav data-upbo-src="src/App.tsx:22" className="flex items-center gap-1">
            {nav.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === '/'}
                className={({ isActive }) =>
                  cn(
                    'rounded-md px-3 py-1.5 text-sm transition-colors',
                    isActive
                      ? 'bg-secondary text-secondary-foreground'
                      : 'text-muted-foreground hover:text-foreground',
                  )
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
        </div>
      </header>

      <main data-upbo-src="src/App.tsx:44" className="flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>

      <footer data-upbo-src="src/App.tsx:52" className="border-t border-border/60">
        <div data-upbo-src="src/App.tsx:53" className="mx-auto w-full max-w-6xl px-6 py-8 text-sm text-muted-foreground">
          © {new Date().getFullYear()} {seo.siteName}
        </div>
      </footer>

      <Toaster position="bottom-right" />
    </div>
  )
}
